/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:20:00
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API_URL } from '@/config';
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'RechargesHistoryDetails',

  props: ['rechargesList'],

  components: { Card },

  computed: {
    downloadRechargesData() {
      return `${API_URL}/recharges/export?from=${this.rechargesList.terms.dateStart}&to=${this.rechargesList.terms.dateEnd}&sortby=${this.rechargesList.terms.sortBy}&sort=${this.rechargesList.terms.sort}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Recharges/RechargesHistoryDetails/component.js